<template>
  <div class="desk_info">
    <form method="POST" action="https://money.yandex.ru/quickpay/confirm.xml" @submit.prevent="pay"
          class="payment_form"
          ref="payForm">
      <input type="hidden" name="receiver" value="41001793679193">
      <input type="hidden" name="formcomment" value="Buy Tariff">
      <input type="hidden" name="short-dest" value="Buy Tariff">
      <input type="hidden" name="label" :value="order.key">
      <input type="hidden" name="quickpay-form" value="donate">
      <input type="hidden" name="targets" :value="'Транзакция ' + order.key">
      <input type="hidden" name="sum" :value="currentPrice" data-type="number">
      <input type="hidden" name="comment" value="Хотелось бы получить дистанционное управление.">
      <input type="hidden" name="successURL" :value="redirect_url">
      <!--    <input type="hidden" name="need-fio" value="true">
          <input type="hidden" name="need-email" value="true">
          <input type="hidden" name="need-phone" value="false">
          <input type="hidden" name="need-address" value="false">-->
      <div class="checks_method">
        <input type="radio" name="paymentType" value="VISA" v-model="paymentType" id="visa">
        <label class="yandex_radio" for="visa">
          <img src="/images/cart-payment_icon.png" alt="Visa Card">
<!--          <img src="/images/credit-card-visa-debit-card-payment-card-mastercard-visa.jpg" alt="Visa Card">-->
        </label>

        <input type="radio" name="paymentType" value="AC" v-model="paymentType" id="card-method" checked>
        <label class="card_radio" for="card-method" style="display: none;">
          <img src="/images/cart-payment_icon.png" alt="Банковской картой">
        </label>

        <input type="radio" name="paymentType" value="PC" v-model="paymentType" id="yandex-method">
        <label class="yandex_radio" for="yandex-method" style="display: none;">
          <img src="/images/yandex-payment_icon.png" alt="Яндекс.Деньгами">
        </label>


      </div>
      <div v-if="paymentType === 'VISA'" class="visa_type" style="display: none;">
        <input type="radio" name="currency" value="AMD" v-model="currency" id="AMD" checked>
        <label class="yandex_radio" for="AMD">
          {{ priceAM }}֏
        </label>

        <input type="radio" name="currency" value="USD" v-model="currency" id="USD">
        <label class="yandex_radio" for="USD">
          {{ priceUSD }}$
        </label>

        <input type="radio" name="currency" value="RUB" v-model="currency" id="RUB">
        <label class="yandex_radio" for="RUB">
          {{ priceRU }}₽
        </label>
      </div>
      <input type="submit" :value="$store.getters.t('transfer')" class="go_pay_button">
    </form>
  </div>
</template>
<script>

  import cvDownloadMix from "../../../mixins/cvDownload";

  export default {
    mixins: [
      cvDownloadMix
    ],
    name: "ButtonPay",
    props: ['order', 'price', 'redirect_url', 'tariff', 'promoCode', 'promoCodes','payment','curr'],
    data(){
      return {
        paymentType:'',
        currency: ''
      }
    },
    computed: {
      priceAM() {
        return this.calculate(this.tariff.price_am)
      },
      priceRU() {
        return this.calculate(this.tariff.price_ru)
      },
      priceUSD() {
        return this.calculate(this.tariff.price)
      },
      currentPrice(){
        return this.calculate(this.price)
      },
    },
    mounted(){
      this.paymentType = this.payment;
      this.currency = this.curr
    },
    watch:{
      paymentType(newVal){
        this.$emit('paymentTypeHandle',newVal)
      },
      currency(newVal){
        this.$emit('currencyHandle',newVal)
      }
    },
    methods: {
      calculate(price) {
        const percent = this.promoCodes.filter( _ => _.code === this.promoCode);
        const discount = percent.length ? percent[0].discount : 0;
        return (price - (price * discount / 100)).toFixed(2);
      },
      async pay() {
        try {
          const res = this.$http({
            method: 'POST',
            url: '/api/payment/click',
            data: {
              paymentType: this.paymentType,
              orderId: this.order.id
            }
          });
        } catch (e) {
        }

        if (this.paymentType !== 'VISA') {

          if(this.promoCode){
            return this.$http({
              method: 'POST',
              url: '/api/payment/order/update',
              data: {
                promoCode: this.promoCode,
                orderId: this.order.id
              }
            }).then( res => {
              this.$refs.payForm.submit();
            });
          }
          return this.$refs.payForm.submit();
        }

        const form = new FormData();
        form.append("OrderID", this.order.id);
        form.append("tariff", this.order.tariff_id);
        form.append("type", "ameriabank");
        form.append("currency", this.currency);
        form.append("promoCode", this.promoCode);

        const initPayment = this.$http({
          method: "POST",
          url: "/api/payment",
          data: form
        }).then(res => {
          window.open(res.data.url, '_blank');
          window.Echo.channel('ameria-waiting-payment-' + this.order.id)
            .listen('PaymentSystem', (e) => {
              if (e.success) {
                this.$store.commit("user", e.user);
                this.downloadCvMix(this.$store.getters.downloadFormat);
              } else {
                this.$store.commit('newMessage', {
                  show: true,
                  type: "error",
                  messageTitle: this.$store.getters.t('payment_message'),
                  message: this.$store.getters.t('payment_error')
                });
              }
              this.$store.commit('modalBuy', false);
              window.Echo.channel('ameria-waiting-payment-' + this.order.id).stopListening('PaymentSystem')
            })
        })
      }
    },
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/modals/buyTariff/buttonPay.vue